module.exports = __webpack_public_path__ + "static/media/encounter.42363a8f.png";